import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "./components/HeroSection";
import CredibilitySection from "./components/CredibilitySection";
import AIGovernanceSection from "./components/AIGovernanceSection";
import ServicesSection from "./components/ServicesSection";
import WhoWeHelpSection from "./components/WhoWeHelpSection";
import EngagementModelSection from "./components/EngagementModelSection";
import WhyStructureSection from "./components/WhyStructureSection";
import AboutSection from "./components/AboutSection";
import CTASection from "./components/CTASection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.state && "scrollTo" in location.state) {
      const id = (location.state as { scrollTo: string }).scrollTo;
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <main>
      <HeroSection />
      <CredibilitySection />
      <AIGovernanceSection />
      <ServicesSection />
      <WhoWeHelpSection />
      <EngagementModelSection />
      <WhyStructureSection />
      <AboutSection />
      <CTASection />
      <ContactSection />
    </main>
  );
}